
    /**
     * @description
     *  Clase de soporte que forece métodos para generar UUIDs.
     */

export class UUID {

    private constructor() {
        throw new Error(
            "Nunca debe instanciar o heredar de esta clase (es de soporte).");
    }

	/**
	 * @description
	 *	Genera un UUID de 128 bits basándose en la implementación de
	 *	'Math.random()'. Este UUID no respeta ninguno de los formatos
	 *	estandarizados aunque para motivos prácticos la probabilidad de
	 *	colisión es suficientemente pequeña durante el lapso de una sesión.
	 *
	 * @returns
	 *	El UUID de 128 bits.
	 */
	public static of128(): string {
		return "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
			.replace(/x/g, pattern => (Math.random() * 16 | 0).toString(16));
	}
}
